import React from 'react';
import Base from './Base';

export default class CustomObligationModal extends Base {
    constructor(props) {
        super(props);
        this.state = {
            lockScreen: 0,
            services: [],
            record: {
                title: '',
                periodType: 1,   // 1:ماهانه, 2:فصلی, 3:سالانه
                dueDay: 15,
                priority: 2,
                serviceId: null
            }
        };
    }

    componentDidMount() {
        // دریافت لیست خدمات فعال
        this.httpPost('api/v1/service/list', {
            page: 1,
            count: 100,
            phrase: '',
})   // نیاز به ایجاد این endpoint یا استفاده از service/list
            .then(data => {
                if (data.status === 1)
                    this.setState({ services: data.records || [] });
            })
            .catch(() => { });
    }

    handleChange(field, value) {
        this.setState({ record: { ...this.state.record, [field]: value } });
    }

    async generate() {
        if (!this.state.record.title.trim()) {
            this.showErorrMessage('عنوان تکلیف الزامی است');
            return;
        }
        this.setState({ lockScreen: 1 });
        this.httpPost('api/v1/legalobligation/generateforcontract', {
            contractId: this.props.contractId,
            ...this.state.record
        }).then(data => {
            this.setState({ lockScreen: 0 });
            if (data.status === 1) {
                this.showSuccessMessage(data.message);
                this.props.onSaved();
            } else {
                this.showErorrMessage(data.message);
            }
        });
    }

    render() {
        const { show, onClose } = this.props;
        const { record, services } = this.state;
        if (!show) return null;

        return (
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">ایجاد تکلیف سفارشی برای قرارداد</h5>
                            <button type="button" className="close" onClick={onClose}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label">عنوان</label>
                                    <input className="form-control" value={record.title}
                                        onChange={e => this.handleChange('title', e.target.value)} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">نوع دوره</label>
                                    <select className="form-select" value={record.periodType}
                                        onChange={e => this.handleChange('periodType', parseInt(e.target.value))}>
                                        <option value="1">ماهانه</option>
                                        <option value="2">فصلی</option>
                                        <option value="3">سالانه</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        {record.periodType === 1 ? 'روز ماه (۱-۳۱)' : 'تعداد روز پس از پایان دوره'}
                                    </label>
                                    <input type="number" className="form-control" value={record.dueDay}
                                        onChange={e => this.handleChange('dueDay', parseInt(e.target.value))} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">اولویت</label>
                                    <select className="form-select" value={record.priority}
                                        onChange={e => this.handleChange('priority', parseInt(e.target.value))}>
                                        <option value="1">کم</option>
                                        <option value="2">متوسط</option>
                                        <option value="3">زیاد</option>
                                        <option value="4">حیاتی</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">سرویس (اختیاری)</label>
                                    <select className="form-select" value={record.serviceId || ''}
                                        onChange={e => this.handleChange('serviceId', e.target.value ? parseInt(e.target.value) : null)}>
                                        <option value="">-- بدون سرویس --</option>
                                        {services.map(s => <option key={s.id} value={s.id}>{s.title}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary" onClick={() => this.generate()}
                                disabled={this.state.lockScreen === 1}>
                                {this.state.lockScreen === 1 && <span className="spinner-border spinner-border-sm"></span>} تولید
                            </button>
                            <button className="btn btn-secondary" onClick={onClose}>انصراف</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}